import React from 'react';
import comercial from '../assets/images/comercial.avif';
import homy from '../assets/images/homy.avif';
import cartia from '../assets/images/cartia.avif';
import artlens from '../assets/images/artlens.avif';
import medicare from '../assets/images/medicare.avif';

const UseCases = () => {
  const cases = [
    {
      icon: '🛍️',
      image: comercial,
      title: 'Retail & Centros Comerciales',
      subtitle: 'Guía inteligente',
      description: 'Avatares que informan, orientan y personalizan cada visita.',
      features: [
        'Info de tiendas y horarios',
        'Localización de productos',
        'Promociones actualizadas',
        'Analítica conversacional'
      ]
    },
    {
      icon: '🏨',
      image: homy,
      title: 'HomyAI',
      subtitle: 'Alquileres vacacionales',
      description: 'Anfitrión virtual 24/7 en Smart TVs.',
      features: [
        'Recomendaciones locales',
        'Gestión de servicios',
        'Soporte multiidioma',
        'Experiencia sin fricciones'
      ]
    },
    {
      icon: '🎓',
      image: cartia,
      title: 'Grandes Superficies',
      subtitle: 'Asistente de compras',
      description: 'Asistente y recomendador de compras.',
      features: [
        'Recomendaciones de productos',
        'Lista de compras',
        'Precio comparativo',
        'Ubicación de productos'
      ]
    },
    {
      icon: '🎨',
      image: artlens,
      title: 'ArtLens',
      subtitle: 'Museos inteligentes',
      description: 'Guías culturales interactivos.',
      features: [
        'Info detallada de obras',
        'Rutas personalizadas',
        'Contenido multimedia',
        'Experiencia inmersiva'
      ]
    },
    {
      icon: '🧭',
      image: medicare,
      title: 'Medicare',
      subtitle: 'Navegación interior',
      description: 'Guía inteligente para grandes espacios.',
      features: [
        'Navegación turn-by-turn',
        'Información contextual',
        'Accesibilidad completa',
        'Puntos de interés'
      ]
    }
  ];

  return (
    <section className="section" id="casos">
      <div className="section-header">
        <div className="section-tag">Verticales</div>
        <h2 className="section-title">Soluciones para Cada Sector</h2>
        <p className="section-subtitle">
          Avatares inteligentes especializados que transforman la experiencia en múltiples industrias.
        </p>
      </div>
      <div className="grid-3">
        {cases.map((caseItem, index) => (
          <div key={index} className="card">
            <span className="card-image"><img src={caseItem.image} alt={caseItem.title} /></span>
            <h3 className="card-title">{caseItem.title}</h3>
            <p className="card-subtitle">{caseItem.subtitle}</p>
            <p className="card-description">{caseItem.description}</p>
            <ul className="card-features">
              {caseItem.features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default UseCases;
